export const ADMIN_GROUP = 'Admin';
export const SUPER_ADMIN_GROUP = 'SuperAdmin';

export const routerLinks = {
   dashboard: '/dashboard',
   wells: '/wells',
   reports: '/reports',
   auditReport: '/audit-report',
   tanksAllocationsReport: '/reports/tanks-allocations',
   productionReport: '/reports/production',
   ogp03iExport: '/reports/ogp03i-export',
   barrelTests: '/barrel-tests',
   runTickets: '/run-tickets',
   pulledBottoms: '/pulled-bottoms',
   users: '/users',
   login: '/login',
   forgotPassword: '/forgot',
   wellListSetup: '/wellListSetup',
   wellSetup: '/wellSetup/:wellId',
   userListSetup: '/userListSetup',
   userSetup: '/userSetup',
   leaseListSetup: '/leaseListSetup',
   leaseSetup: '/leaseListSetup/:leaseId',
   priceConfigSetup: '/priceConfigSetup',
   dailyReport: '/wells/:wellId/report',
   barrelTestTrend: '/barrel-tests/:wellId/trend',
};

// Dedicated full-page well editor (see routes/AppRoutes.tsx + WellEditPage) —
// builds a concrete path from the :wellId route param above, same
// convention as wellDailyReportPath just below. Pass 'new' to land on
// the create flow (WellEditPage treats that id as "no well loaded yet").
// Optional returnTo (an in-app path) makes WellEditPage's Cancel/Save go
// back there instead of the Wells list — see lib/returnTo.ts.
export function wellSetupPath(wellId: string, returnTo?: string) {
   const base = `/wellSetup/${wellId}`;
   return returnTo ? `${base}?returnTo=${encodeURIComponent(returnTo)}` : base;
}

// Selects a lease within the master-detail Lease list (see
// routes/AppRoutes.tsx + LeaseAdminPage, which renders LeaseEditPage
// itself once :leaseId is present — there's no separate full-page editor
// route anymore). Unlike wellSetupPath, there's no 'new' sentinel:
// LeaseAdminPage creates the lease record (in leasesAtom) up front and
// navigates straight to its real id, so LeaseEditPage never has to handle
// a not-yet-existing lease.
export function leaseSetupPath(leaseId: string) {
   return `${routerLinks.leaseListSetup}/${leaseId}`;
}

// Mobile Daily Input page — builds a concrete path from the
// :wellId route param above (see routes/AppRoutes.tsx + DailyReportPage).
export function wellDailyReportPath(wellId: string) {
   return `/wells/${wellId}/report`;
}

// Mobile "tap a well to see its trend" page (see routes/AppRoutes.tsx +
// BarrelTestTrendPage) — full-screen, no TopNav/BottomNav, same treatment
// as wellDailyReportPath above.
export function barrelTestTrendPath(wellId: string) {
   return `/barrel-tests/${wellId}/trend`;
}
